// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = () => {
  return [
    {
      name: '调整结算数量',
      prop: 'adjustStatementQuantity',
      type: 'inputNumber',
      span: 7,
      precision: 3,
      changeMethod: 'changeMethod',
    },
    {
      name: '调整结算单价(含税)',
      prop: 'adjustOriginalPrice',
      type: 'inputNumber',
      span: 7,
      changeMethod: 'changeMethod',
      precision: 3,
    },
    {
      name: '调整原币结算金额(含税)',
      prop: 'adjustOriginalAmount',
      type: 'inputNumber',
      precision: 2,
      disabled: true,
      changeMethod: 'changeMethod',
      span: 7,
    },
    {
      name: '调整原因',
      prop: 'adjustReason',
      type: 'input',
      span: 24,
    },
  ];
};
export const tableRules = {
  adjustStatementQuantity: [{ required: true, message: '必填字段' }],
  adjustOriginalPrice: [{ required: true, message: '必填字段' }],
  adjustOriginalAmount: [{ required: true, message: '必填字段' }],
  adjustReason: [{ required: true, message: '必填字段' }],
};
